import styled from 'styled-components';
import { Text } from '../../Typography/Text/Text';

export const TooltipText = styled(Text)`
  background-color: ${(props) => props.theme.colours.tooltip.background};
  padding: 1rem;
`;
